<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="红冲申请" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item label="申请编码">
									<el-input v-model="searchForm.code" placeholder="请填写申请编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="发票编码">
									<el-input v-model="searchForm.invoice_code" placeholder="请填写开票编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="状态">
									<el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="申请时间">
									<el-date-picker v-model="searchForm.create_time" type="daterange" format="yyyy-MM-dd"
										value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="doSearch">查询</el-button>
									<el-button type="primary" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar" style="margin-top:0;"
								v-if="$parent.$parent.isAuthAction('admin/customers/customer/addhongchonginvoice')">
								<div>
									<el-button type="primary" size="mini" @click="addInvoiceOpen"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/addhongchonginvoice')">红冲申请</el-button>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" border stripe ref="table" v-loading="loading"
									highlight-current-row :height="tableHeight">
									<el-table-column fixed prop="hongchong_code" label="红冲申请编码" min-width="250">
										<template slot-scope="scope">
											<el-link type="primary" style="font-size: 12px; text-decoration: underline;" :underline="false"
												@click="detail(scope.row)" target="_blank">{{ scope.row.hongchong_code }}</el-link>
										</template>
									</el-table-column>
									<el-table-column prop="invoice_code" label="红冲发票编码" min-width="200">
									</el-table-column>
									<el-table-column prop="used_cost" label="红冲金额" width="200">
									</el-table-column>
									<el-table-column prop="uid_txt" label="申请人" width="100">
									</el-table-column>
									<el-table-column prop="create_time" label="申请时间" width="150">
									</el-table-column>
									<el-table-column fixed="right" prop="status_txt" align="center" label="状态" width="100">
									</el-table-column>
									<el-table-column fixed="right" label="操作"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/confirmsubmitreinvoice') || $parent.$parent.isAuthAction('admin/customers/customer/delhongchonginvoice')"
										width="140">
										<template slot-scope="scope">
											<el-button :disabled="!(scope.row.status == 1)" @click="addConfirmForm(scope.row)" type="text"
												:size="size"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/confirmsubmitreinvoice')">提交审批</el-button>
											<el-button :disabled="!(scope.row.status == 1)" type="text" @click="handleDelete(scope.row)"
												:size="size"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/delhongchonginvoice')">删除申请</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--申请红冲-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" :close-on-press-escape='false'
			:wrapperClosable='false' size="70%">
			<!-- :rules="rules.addForm" -->
			<el-form :model="addForm" ref="addForm" :rules="rules.addForm" :size="size" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>申请红冲</span>
						<i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
					</div>
				</div>
				<div class="drawer-content">
					<el-form-item label="发票选择" prop="id">
						<el-select v-model="addForm.id" clearable placeholder="请输入您要搜索的发票号" style='width: 100%;' filterable remote
							reserve-keyword :remote-method="getInvoice" @change="setInfo">
							<el-option v-for="item in options.supplier_id_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<div v-if="addForm.id" style="color: #606266; margin-top: 5px;">
							<el-row type="flex" class="row-bg" justify="center">
								<el-col :span="12">发票抬头: {{ addForm.drawer_id_txt }}</el-col>
								<el-col :span="12">发票类型: {{ addForm.invoice_rate }}</el-col>
							</el-row>
							<el-row type="flex" class="row-bg" justify="center">
								<el-col :span="12">发票类目: {{ addForm.invoice_info_txt }}</el-col>
								<el-col :span="12">票面金额: {{ addForm.invoice_cost }}</el-col>
							</el-row>
						</div>
					</el-form-item>
					<el-form-item label="红冲明细" prop="ids" v-if="addForm.id">
						<el-select v-model="addForm.ids" multiple filterable clearable placeholder="请选择相关明细" style='width: 100%;'
							@change="addForeach">
							<el-option v-for="item in options.execute_ids_options" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-row v-for="(item, index) in addForm.array_list" :key="index" v-if="addForm.ids.length > 0">
						<el-form-item style="margin-bottom: 0;">
							<el-col :span="16">
								<el-form-item label="明细" label-width="78px">
									<el-input v-model="item.label" clearable disabled></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="申请红冲金额:" label-width="128px" :prop="'array_list.' + index + '.value'"
									:rules="[{ required: true, validator: validatePass, trigger: 'blur' }]">
									<el-input v-model="item.value"></el-input>
								</el-form-item>
							</el-col>
						</el-form-item>
					</el-row>
					<!-- <el-form-item label="红冲金额" prop="cost">
					<div style="display: flex;">
						<div style="width: 220px; margin-right: 10px;">
							<el-input v-model="addForm.cost" placeholder="请填写红冲金额" clearable></el-input>
						</div>
						<span style="color: #F56C6C;" v-if="addForm.id">(可红冲金额：{{addForm.used_cost}})</span>
					</div>
				</el-form-item> -->
					<el-form-item label="申请备注">
						<el-input v-model="addForm.remark" placeholder="请填写备注" type="textarea" clearable></el-input>
					</el-form-item>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="addInvoice" :size='size'>提交</el-button>
					<el-button :size='size' @click="addFormVisiable = false">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
	</div>
</template>
<script>
export default {
	props: ['info'],
	data () {
		return {
			loading: false,
			addFormVisiable: false,
			activeName: 'first',
			size: 'mini',
			options: {
				invoice_type_options: [
					{
						value: 1,
						label: '普票'
					}, {
						value: 2,
						label: '专票'
					}, {
						value: 3,
						label: '形式发票'
					}
				],
				business_type_options: [
					{
						value: 1,
						label: '返点收入'
					}, {
						value: 2,
						label: '项目收入'
					}
				],
				status_options: [
					{
						value: 1,
						label: '待提交'
					}, {
						value: 2,
						label: '待审核'
					}, {
						value: 3,
						label: '被驳回'
					}, {
						value: 4,
						label: '正常'
					}
				],
				customer_id_options: [],//客户下拉
				project_ids_options: [],//项目下拉
				invoice_item_options: [],//发票类目
				invoice_id_options: [],//发票类型
				supplier_id_options: [],//供应商下拉
				execute_ids_options: []//执行下拉
			},
			searchForm: {
				code: '',
				invoice_code: '',
				status: '',
				create_time: []
			},
			resetSearch: {
				invoice_code: '',
				status: '',
				create_time: []
			},
			addForm: {
				id: '',
				cost: '',
				remark: '',
				ids: [],
				array_list: [],
				drawer_id_txt: '',
				invoice_rate: '',
				invoice_info_txt: '',
				invoice_cost: '',
				used_cost: ''
			},
			rules: {
				addForm: {
					'id': [
						{ required: true, message: '请选择发票', trigger: ['change'] }
					],
					//   'cost': [
					// 	{required: true, message: '请填写红冲金额', trigger: ['blur']},
					// 	{ validator: this.validatePass, trigger: 'blur' }
					//   ],

				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			invoice_open_list: [],//发票信息集合
			invoice_tips: ''//发票提示
		}
	},
	computed: {
		isSupper: function () {
			return this.info.views.isSupper
		},
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	watch: {
	},
	mounted: function () {
		//this.handleSearch(this.searchForm);
	},
	methods: {
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		addForeach (value) {
			var arr = []
			this.options.execute_ids_options.forEach(function (item, index) {
				if (value.indexOf(item.value) != -1) {
					arr.push({
						key: item.value,
						type: item.type,
						label: item.label,
						value: ''
					})
				}
			}.bind(this))
			this.$set(this.addForm, 'array_list', arr)
			
		},
		getInfoList (value) {
			this.$api.get('/admin/customers/customer/getbyinvoicetoexecuorpro', { id: value }).then(res => {
				if (res.code === 0) {
					this.options.execute_ids_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		// 申请收票弹窗
		addInvoiceOpen () {
			this.addForm = {
				id: '',
				cost: '',
				remark: '',
				drawer_id_txt: '',
				invoice_rate: '',
				invoice_info_txt: '',
				invoice_cost: '',
			}
			this.getInvoice()//获取发票下拉
			this.addFormVisiable = true;
		},
		handleDelete (row) {
			this.$confirm('此操作将永久删除该条申请, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/customers/customer/delhongchonginvoice', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该申请已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		// 申请收票
		addInvoice () {
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/customers/customer/addhongchonginvoice', this.addForm).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.handleSearch();
							this.$message({
								showClose: true,
								message: '红冲申请成功！',
								type: 'success'
							});
						} else {
							this.$message.error(res.msg);
						}
						this.addFormVisiable = false;
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
				this.loading = false
			}.bind(this));
		},
		setInfo: function (value) {
			this.addForm.ids = []
			this.getInfoList(value)
			this.options.supplier_id_options.forEach(function (item, index) {
				if (item.value == value) {
					this.addForm.cost = item.used_cost
					this.addForm.used_cost = item.used_cost
					this.addForm.drawer_id_txt = item.info.drawer_id_txt
					this.addForm.invoice_rate = item.info.invoice_rate
					this.addForm.invoice_info_txt = item.info.invoice_info_txt
					this.addForm.invoice_cost = item.info.invoice_cost
				}
			}.bind(this))
		},
		validatePass: function (rule, value, callback) {
			if (!/^[+]?\d+(\.\d{1,2})?$/.test(value)) {
				// 验证失败，返回错误信息
				callback(new Error('发票金额格式不正确,例:120.35'))
			}
			// var cost = 0
			// this.addForm.array_list.forEach(function (item, index) {
			// 	cost += Number(item.value)
			// })
			// if (cost*100 > this.addForm.used_cost * 100) {
			// 	// 验证失败，返回错误信息
			// 	callback(new Error('红冲金额超出可申请金额（含待审核）' + this.addForm.used_cost + '元'))
			// }
			callback()
		},
		addConfirmForm (row) {
			this.loading = true
			this.$api.post('/admin/customers/customer/confirmsubmitreinvoice', { id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该申请已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		handleSearch: function (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/customers/customer/hongchonginvoicelist', param).then(res => {
				if (res.code === 0) {
					this.tableData = res.data;
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		//获取供应商下拉
		getInvoice (query) {
			this.$api.get('/admin/customers/customer/getinvioceentryselect', { 'query': query,'redType':'RED' }).then(res => {
				if (res.code === 0) {
					this.options.supplier_id_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'OpenDetail',
				query: { id: row.id, set_id: 19, type: 'detail' }
			});
		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			// 使用 === 进行严格相等判断
			if (from.path !== '/openDetail') {
				try {
					vm.reset();
				} catch (error) {
				}
			}
		});
	}
}
</script>
<style type="text/css" scoped>
.el-table .el-form-item--mini.el-form-item,
.el-table .el-form-item--small.el-form-item {
	margin-bottom: 0;
}
</style>